import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/database'

export const firebaseApp = firebase.initializeApp({
  apiKey: 'AIzaSyBdYJbz1V_I1wkf344AnVtsrj4syykrQK8',
  authDomain: 'graviaguas-7b8f9.firebaseapp.com',
  databaseURL: 'https://graviaguas-7b8f9.firebaseio.com',
  projectId: 'graviaguas-7b8f9',
  storageBucket: 'graviaguas-7b8f9.appspot.com',
  messagingSenderId: '772703546314',
  appId: '1:772703546314:web:45ee18d9dd9d24da7f7d33'
})

export default function install (Vue) {
  Object.defineProperty(Vue.prototype, '$firebase', {
    get () {
      return firebaseApp
    }
  })
}
